module.exports = __webpack_public_path__ + "static/media/encabezado.bda6fc88.png";